function parser(hint) {
    return {
        stringify(value) {
            if (hint === "string" && typeof value === "string") {
                return stringParser.stringify(value);
            }
            if (hint === "date" && value instanceof Date) {
                return dateParser.stringify(value);
            }
            return defaultParser.stringify(value);
        },
        parse(value) {
            if (hint === "string") {
                return stringParser.parse(value);
            }
            if (hint === "date") {
                return dateParser.parse(value);
            }
            return defaultParser.parse(value);
        },
    };
}
const defaultParser = JSON;
const stringParser = { stringify: (value) => value, parse: (value) => value };
const dateParser = {
    stringify(value) {
        return value.toISOString();
    },
    parse(value) {
        return new Date(value);
    },
};
export { parser };
